var _defs, _path, _path2, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnv0WorkflowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "env0-workflow-icon_svg__a",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".env0-workflow-icon_svg__d{stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1px}.env0-workflow-icon_svg__g{fill:#7affc3}"))), /*#__PURE__*/React.createElement("path", {
    d: "M14 0c7.74 0 14 6.27 14 14.03C28 21.73 21.71 28 14 28S0 21.72 0 14 6.28 0 14 0",
    style: {
      fill: "#0e0f38"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.05 8.55h5.26m4.64.27v5.01m0 5.62v-4.93",
    className: "env0-workflow-icon_svg__d"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 2.25,
    x: 13.53,
    y: 7.33,
    rx: 0.36,
    ry: 0.36,
    style: {
      fill: "#00edb9"
    },
    transform: "rotate(-180 16.85 8.555)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.05,
    cy: 8.55,
    r: 1.35,
    style: {
      fill: "#00eefe"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05 14.07v5.56m9.9-5.8h-6.53",
    className: "env0-workflow-icon_svg__d"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 2.25,
    x: 7.83,
    y: 12.6,
    rx: 0.34,
    ry: 0.34,
    style: {
      fill: "#947eff"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.95,
    cy: 13.83,
    r: 1.35,
    className: "env0-workflow-icon_svg__g"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 2.25,
    x: 7.83,
    y: 18.22,
    rx: 0.34,
    ry: 0.34,
    style: {
      fill: "#1aaefc"
    }
  }), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.95,
    cy: 19.45,
    r: 1.35,
    className: "env0-workflow-icon_svg__g"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnv0WorkflowIcon);
export default __webpack_public_path__ + "static/media/env0-workflow-icon.f40a7cdbfc6f0dc873a010f284c6cb1f.svg";
export { ForwardRef as ReactComponent };